import React from 'react';
import classnames from 'classnames';

type SpinnerProps = {
  size?: 'large' | 'small' | 'normal';
  className?: string;
};

/**
 * Themed loading spinner rendered while the SymbolPicker fetches search
 * results. Implemented with plain CSS (keyframes in SymbolPicker.scss) so we
 * don't need any extra runtime dependencies.
 */
export const Spinner: React.FC<SpinnerProps> = ({size = 'normal', className}) => (
  <div className={classnames('sp-spinner', {
    'sp-spinner--small': size === 'small',
    'sp-spinner--large': size === 'large',
  }, className)}>
    <div className='sp-spinner-inner'>
      <div className='sp-spinner-track' />
      <div className='sp-spinner-bar' />
    </div>
  </div>
);
